export const CAPITALIZED_MONTHS = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
] as const

export const CAPITALIZED_SHORT_MONTHS = [
  'Janv.',
  'Févr.',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juil.',
  'Août',
  'Sept.',
  'Oct.',
  'Nov.',
  'Déc.',
] as const

export const MONTHS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
] as const

export type FullMonth = (typeof MONTHS)[number]
export type CapitalizedMonth = (typeof CAPITALIZED_MONTHS)[number]
export type CapitalizedShortMonth = (typeof CAPITALIZED_SHORT_MONTHS)[number]
